import { nullable, number, object, string } from "superstruct";

const GiftRegistryItemSchema = object({
    giftRegistryId: number(),
    productId: number(),
    variantId: number(),
    quantity: number(),
    tag: nullable(string()),
    id: number(),
    purchasedAmount: number(),
    createdAt: string(),
    updatedAt: nullable(string()),
});

export default GiftRegistryItemSchema;
